<div class="icon-text">
  <div class="icon-border">
    <ui-icon faName="circle-check" faStyle="light"></ui-icon>
  </div>
  <span>Bestellung eingegangen</span>
</div>

<div class="text">
  <h6>Geschafft – vielen Dank! 🎉</h6>
  <p>Ihre Bestellung ist bei uns eingegangen.</p>

  <div class="availability-text">
    <p>Die Verfügbarkeit Ihrer Artikel wird <strong>automatisch</strong> geprüft.</p>
    <p>Den <strong>aktuellen Status</strong> Ihrer Bestellung sehen Sie in <strong>wenigen Minuten</strong> in der Bestellübersicht.</p>
  </div>

  <ui-button [routerLink]="'/orders'" icon="arrow-right">Zur Bestellübersicht</ui-button>
</div>
